export const getDefaultChecksState = () => {
    return {
        allServices: [],
        allReports: [],
        basket: [],
    };
};
export const state = getDefaultChecksState();
